/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { CreateOAuthClientPage } from '@/pages/OAuthClients/CreateOAuthClientPage';

export function CreateOAuthClientRoute() {
  return <CreateOAuthClientPage />;
}
